import { ChevronDownIcon, ChevronUpIcon } from '@40seas/frontend/common/icons';
import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const selectTheme: { defaultProps?: ComponentsProps['MuiSelect']; styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'] } = {
    defaultProps: {
        IconComponent: (props) => {
            const Icon = props.className.includes('MuiSelect-iconOpen') ? ChevronUpIcon : ChevronDownIcon;
            const right = props.className.includes('MuiSelect-iconStandard') ? 0 : 1;

            return (
                <Icon
                    sx={{
                        position: 'absolute',
                        right: (theme: any) => theme.spacing(right),
                        pointerEvents: 'none',
                    }}
                />
            );
        },
    },
    styleOverrides: {
        root: ({ theme, ownerState }) => ({
            color: ownerState.color && theme.palette[ownerState.color].main,
        }),
        select: ({ theme, ownerState }) => ({
            color: ownerState.color && theme.palette[ownerState.color].main,
        }),
        standard: ({ theme }) => ({
            paddingTop: theme.spacing(0.5),
            paddingBottom: theme.spacing(0.5),
            paddingLeft: theme.spacing(0.5),
            '.Mui-focused &': {
                backgroundColor: 'transparent',
            },
        }),
        outlined: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
        }),
    },
};
